import { useEffect, type DependencyList } from "react";

type Cleanup = () => void;
type LoadEffect = (
  signal: AbortSignal,
) => void | Cleanup | Promise<void | Cleanup>;

// Async initialization runs after commit. Each effect owns its requests and cleanup.
export default function useLoadEffect(
  callback: LoadEffect,
  dependencies: DependencyList,
): void {
  useEffect(() => {
    const controller = new AbortController();
    let cleanup: void | Cleanup;
    Promise.resolve()
      .then(() => {
        if (controller.signal.aborted) return;
        return callback(controller.signal);
      })
      .then((result) => {
        if (controller.signal.aborted) {
          if (typeof result === "function") result();
        } else cleanup = result;
      })
      .catch((error) => {
        if (!controller.signal.aborted)
          console.error("Impossible de charger les données", error);
      });
    return () => {
      controller.abort();
      if (typeof cleanup === "function") cleanup();
    };
  }, dependencies);
}
